import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'src/app/features/auth/services/auth.service';

export const authGuard: CanActivateFn = (_route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const isAuthenticated = authService.getAuthStatus();

  if (!isAuthenticated) {
    router.navigate([''], { queryParams: { next: state.url } });
  }
  return isAuthenticated;
};
